import React, { useContext, useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { AuthCtx } from '../context/AuthContext';
import { api } from '../services/api';

const beaconLogout = () => {
  const token = localStorage.getItem('clientToken');
  if (!token) return;
  const body = JSON.stringify({ token });
  navigator.sendBeacon(
    '/api/clientes/logout-beacon', // <-- reemplaza con tu URL real si es necesario
    new Blob([body], { type: 'application/json' })
  );
};


export default function Header() {
  const navigate = useNavigate();
  const { fullName, logout } = useContext(AuthCtx);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clienteNombre, setClienteNombre] = useState('');

  const isAuthenticated = !!localStorage.getItem('token');

  useEffect(() => {
    const nombre = localStorage.getItem('clienteNombre');
    if (nombre) setClienteNombre(nombre);
  }, []);

  useEffect(() => {
    const handleVisibility = () => {
      // Solo cerrar sesión si la página se está cerrando/ocultando definitivamente
      if (document.visibilityState === 'hidden') {
        // No hacer nada aquí — el beacon solo debe ir en beforeunload
      }
    };
  
    const handleBeforeUnload = () => {
      beaconLogout();
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleStatsClick = () => {
    handleCloseMenu();
    navigate('/admin/stats');
  };

  const handleLogout = async () => {
    beaconLogout();
    localStorage.clear();
    if (logout) logout();
    navigate('/');
    window.location.reload();
  };

  return (
    <AppBar position="static" sx={{ background: '#b71c1c' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* lado izquierdo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer' }}
             onClick={() => navigate('/')}>
          <Home sx={{ fontSize: 30, color: 'white' }} />
          <Typography variant="h6" color="white">
            INICIO
          </Typography>
          {(fullName || clienteNombre) && (
            <Typography sx={{ ml: 2 }} color="white">
              Bienvenido: {fullName || clienteNombre}
            </Typography>
          )}
        </Box>

        {/* lado derecho */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button color="inherit" onClick={() => navigate('/admin')}>
  ADMINISTRACIÓN
</Button>

          {isAuthenticated && (
            <>
              <Button color="inherit" onClick={handleMenu}>
                VER ESTADÍSTICAS
              </Button>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                <MenuItem onClick={handleStatsClick}>Estadísticas</MenuItem>
              </Menu>
            </>
          )}

{isAuthenticated && (
  <Button color="inherit" onClick={() => navigate('/admin/sesiones')}>
    SESIONES
  </Button>
)}

          {(fullName || clienteNombre) && (
            <Button color="inherit" onClick={handleLogout}>
              CERRAR SESIÓN
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
